import { render } from "./RockHeaderNotification.vue?vue&type=template&id=55c7d4fd&scoped=true"
import script from "./RockHeaderNotification.vue?vue&type=script&lang=js"
export * from "./RockHeaderNotification.vue?vue&type=script&lang=js"

import "./RockHeaderNotification.vue?vue&type=style&index=0&id=55c7d4fd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c7d4fd"]])

export default __exports__